$('.return-back').on('click', function (e) {
    e.preventDefault();
    history.back();
})
